var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"aa56394396f2f4e8cce9ef6b0e532b17694b9cad"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docupet-app-registration@docupet"]={id:"aa56394396f2f4e8cce9ef6b0e532b17694b9cad"};
      